module.exports = __webpack_public_path__ + "img/customer-a-039.3bab3607.png";